// Partials
import { Maps } from "~/pages/RealEstateProduct/RealEstateProject/Partials/Project/Partials/Maps";

// Utils
import { getCondomminiuMaturity } from "~/pages/RealEstateProduct/utils/functions";

// Types
import type { ILocationProps } from "./types";

export function Location({REP_PROJECT,infocusID,locationCompletions}: ILocationProps) {

    // AUX Variables
    const PROJECT_MAD = getCondomminiuMaturity(REP_PROJECT)

    return (
        // <h2>Teste</h2>
        <div data-infocusID={infocusID === 2}
            className="md:absolute
                print:!relative
                print:!left-0
                border-[1px] border-r-[#000]
                last-of-type:border-none
                opacity-100 -left-[100%]
                data-[inFocusID=true]:opacity-0
                data-[inFocusID=true]:left-0
                transition-all duration-[0.38s]
                w-full h-screen flex flex-col justify-between gap-4 p-16 bg-white
                page-break
            "
        >
            <span className="w-full h-auto flex flex-row items-center justify-between gap-4">
                <span className="text-5xl">Localização</span>
                <span className="text-2xl">MCF | Sócios</span>
            </span>

            <div className="w-[40%] flex-1 max-h-[50%] self-center bg-[#d5d5d5] rounded-md overflow-hidden">
                {
                    REP_PROJECT?.localization && (
                        <Maps onDoSearch={false} searchInput={REP_PROJECT?.localization}  withOut={true}/>
                    )
                }
            </div>

            <div className="w-full h-auto flex flex-row justify-center flex-nowrap gap-4 relative">
                <span className="flex-1 flex flex-col gap-2 max-w-[40%] p-8 rounded-xl bg-[#e1eeea]">
                    <span className="font-semibold">Distância até a capital</span>

                    <span className="mb-3">
                        {
                            REP_PROJECT?.localization || 'N/A'
                        }
                    </span>

                    <ul className="flex flex-col md:max-h-32 md:overflow-y-auto text-[#737373] font-medium gap-2 print:!h-[10cm]">
                        {
                            locationCompletions?.choices[0].message.content?.split('\n').map((d, index) => (<li className="list-type-dot">
                                {d}
                            </li>))
                        }
                    </ul>

                </span>
                <span className="flex-1 flex flex-col gap-4 p-8 rounded-xl bg-[#e1eeea]">
                    <span className="font-bold text-xl">Maturidade do Condominio</span>

                    <span className="w-full flex flex-row items-center flex-nowrap gap-4">
                        <span className="w-full md:h-8 print:!h-[2cm] rounded-2xl bg-white flex flex-row items-center overflow-hidden">
                            <span data-percent={PROJECT_MAD} className="h-full rounded-r-[20px] bg-[#087958]" style={{ width: `${PROJECT_MAD}%` }}></span>
                        </span>
                        <span className="font-bold text-xl">{PROJECT_MAD}%</span>
                    </span>
                </span>
            </div>
        </div>
    )
}
